import { NgModule } from '@angular/core';
import { ImportTypeModule } from '../../import-type';
import { ImportTypeCellRendererComponent } from './import-type-cell-renderer.component';

@NgModule({
  imports: [ImportTypeModule],
  declarations: [ImportTypeCellRendererComponent],
  exports: [ImportTypeCellRendererComponent],
})
export class ImportTypeCellRendererModule {}
